export const colors = {
    background: '#100f10',
    text: '#FFF',
    lightgrey: '#f2f2f2',
    offwhite: '#8C8C8C',
    primary: '#053C5E',
    red: '#E61E25',
    grey: 'grey',
    white: 'white',
}